export const environment = {
  production: true,
  //  backendApiURL: "https://api.healthco.app/",
  backendApiURL: "https://apihealthco.codknox.com/",
  translate: 'en' // english
};

